import { FunctionComponent, PropsWithChildren, useRef } from 'react';

import { Metrics } from '../metrics';
import { TelemetryMetricsProps } from '../../types';
import { MetricsContext } from './metrics-context';

/**
 * OpenTelemetry Provider for React to initialize and provide metrics tracking.
 */
export const MetricsProvider: FunctionComponent<
  PropsWithChildren<TelemetryMetricsProps>
> = ({ children, client, ...rest }) => {
  // We use a ref to avoid re-initializing the Metrics instance on hot reloading and re-renders
  const metrics = useRef(
    new Metrics({
      client,
      ...rest,
    })
  );

  return (
    <MetricsContext.Provider
      value={{
        metrics: metrics.current,
      }}
    >
      {children}
    </MetricsContext.Provider>
  );
};
